export default [
  {
    path: "test-drives",
    name: "test-drives",
    component: () => import("../TestDrives.vue"),
    meta: {
      title: "Test Drives",
      description: "Test Drives",
      sort: 0,
      authenticatable: true,
      permission: false,
      icon: "test-drives",
      roles: ["admin", "dealer"]
    },
  },
  {
    path: "test-drives-units",
    name: "test-drives-units",
    component: () => import("../TestDrivesUnits.vue"),
    meta: {
      title: "Test Drive Units",
      description: "Test Drives Units",
      sort: 0,
      authenticatable: true,
      permission: false,
      icon: "test-drives",
      roles: ["admin"]
    },
  },
  {
    path: "test-drives-units-upload",
    name: "test-drives-units-upload",
    component: () => import("../TestDriveUnitsUpload.vue"),
    meta: {
      title: "Test Drive Units Upload",
      description: "Test Drives Units Upload",
      sort: 0,
      authenticatable: true,
      permission: false,
      icon: "test-drives",
      roles: ["admin"]
    },
  },
  {
    path: "test-drives-upload",
    name: "test-drives-upload",
    component: () => import("../TestDriveUpload.vue"),
    meta: {
      title: "Test Drives",
      description: "Test Drives",
      sort: 0,
      authenticatable: true,
      permission: false,
      icon: "test-drives-upload",
      roles: ["admin", "dealer"]
    },
  },
];
